




























































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import WorkerDto from '@/models/Workers/WorkerDto';
import UpdateWorkerPayrollDetailsRequest from '@/models/Workers/UpdateWorkerPayrollDetailsRequest';
import ListUtils from '@/lib/listUtils';

@Component({
  name: 'WorkerPayrollDetailsEdit',
})
export default class extends GiganautVueDialog {

  public dialog = false;
  public worker = new WorkerDto();

  @Watch('dialog')
  onDialogChanged(val: boolean) {
    if (val) {
      this.worker = JSON.parse(JSON.stringify(WorkerDetailsModule.currentWorker));
    }
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }

  get ukStarterDeclarations() { return ListUtils.ukStarterDeclarations(); }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateWorkerPayrollDetailsRequest();
    request.updatedAt = this.worker.updatedAt;
    request.payrollNumber = this.worker.payrollNumber || '';
    request.nationalInsuranceNumber = this.worker.nationalInsuranceNumber || '';
    request.ukStarterDeclaration = this.worker.ukStarterDeclaration;
    request.externalPayrollSystemId = (this.worker.externalPayrollSystemId || '').trim();

    await WorkerDetailsModule.editPayrollDetails(request);
    this.dialog = false;
  }
}
